import React, { useState } from "react";
import Item from "../../../businessFoundation/axiom/module/js/components/Form/Item";
import { Icon } from "../../../businessFoundation/axiom/module/js/components/Icon/icon";
import Link from "../../../businessFoundation/axiom/module/js/components/Link";
import { FieldProp } from "../model/FieldProp";
import ReferenceDataDialog from "./ReferenceDataDialog";
import { MetaClassDataModel as Record } from "../../../businessFoundation/MetaClassData/MetaClassDataList/MetaClassDataModel";
import { Controller } from "react-hook-form";

const ReferenceField: React.FC<FieldProp<any>> = (props) => {
    const { index, property: { isNullable, friendlyName, otherData }, setValue, control, errors } = props;
    const [selectedObject, setSelectedObject] = useState<Record | null>(otherData.selectedObject)
    const [openDialog, setOpenDialog] = useState<boolean>(false)

    return (
        <>
            <Controller
                name={`extendedProperties[${index}].value`}
                control={control}
                rules={{
                    required: {
                        value: !isNullable,
                        message: `${friendlyName} is required`,
                    },
                }}
                render={() => (
                    <Item>
                        <label data-oui-component="true" className="oui-label">
                            {friendlyName}
                        </label>
                        <Link
                            style="default"
                            onClick={() => setOpenDialog(true)}
                        >
                            {selectedObject ? selectedObject.properties.filter(prop => prop.name == otherData.refTitleFieldName)[0].value : "Not Set"} <Icon name="pen" size="small" />
                        </Link>
                        {errors.extendedProperties && errors.extendedProperties[index]?.value && <div className="mdc-text-field-helper-line padding-left-none">
                            <p className="mdc-text-field-helper-text">
                                {errors.extendedProperties ? errors.extendedProperties[index]?.value?.message ?? "" : ""}
                            </p>
                        </div>}
                    </Item>
                )}
            />
            {openDialog && <ReferenceDataDialog
                className={otherData.refMetaClassName}
                closeDialog={() => setOpenDialog(false)}
                object={selectedObject}
                setObject={(record: Record | null) => {
                    if (record) {
                        setValue(`extendedProperties[${index}].value`, record.primaryKeyId, { shouldDirty: true, shouldValidate: true })
                    } else {
                        setValue(`extendedProperties[${index}].value`, null, { shouldDirty: true, shouldValidate: true })
                    }
                    setSelectedObject(record)
                }}
            />}
        </>
    );
};

export default ReferenceField;
